import { Stack } from '@mui/material';
import { PageHeaderStatic, PageTitle, WidgetIcon } from '@procureai/ui-mui';
import { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { I18nNamespace, RuleDomainType } from '~/common/types';
import { DomainIcon } from '~/components/DomainIcon/DomainIcon';

export interface PageHeaderDomainProp {
  domain: RuleDomainType;
}

export const RuleListPageHeader = ({ domain, children }: PropsWithChildren<PageHeaderDomainProp>) => {
  const { t } = useTranslation(I18nNamespace.ruleBuilder);
  const title = t(`ListPage.title`);
  return (
    <PageHeaderStatic
      title={
        <>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          <PageTitle title={title} />
        </>
      }
      maxWidth={false}
      icon={<WidgetIcon icon={<DomainIcon domain={domain} />} />}
      right={
        <Stack
          spacing={3}
          direction="row"
          sx={{
            overflow: 'hidden',
            alignItems: 'center',
          }}
        >
          {children}
        </Stack>
      }
    />
  );
};
